var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#002b7f",
    d: "M.7 0H54v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.7 20H54v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "M15 8.2v4.1h-4.3q-.9-1.4-1-3 .2-1.7 2-1.8 1.8.1 3.4.7m-4.8.1v2.4Zm.3-.2v3.2Zm.4-.2v3.8Zm.3 0v3Zm.4 0v3Zm.3-.2V11Zm.3 0V11Zm.4 0V11Zm.3 0V11Zm.4.3v3Zm.3 0v3.5Zm.3 0v3.2Zm.4 0v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M10.3 8.3v2.4m.3-2.6v3.2m.4-3.4v3.8m.3-3.8v3m.4-3v3m.3-3.2V11m.3-3.2V11m.4-3.1v3m.3-3V11m.4-3v3.2m.3-3v3.4M14 8v3.2m.4-3.2v3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M12.4 7.9c.7 0 2.3.8 2.1 1.8-.2 1.4-1 .9-2.1.7l-.9.2q-.5.6-1 .2H10v2h5.4V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M14.9 7.9a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7m-.8-.2a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M13.4 7.5a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7m-.8-.1a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M11.9 7.3a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7m-.8 0a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m-.7.3a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7m-.6.4a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m-.4.6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m-.2.7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 .7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .7m.1.7a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M15 8v.4c-.9-.1-2-.6-3.1-.6q-1.7 0-1.8 1.4 0 1.6 1 2.8l-.6.3q-.9-1.4-1-3c0-1 .8-2 2.2-2 1.1 0 2.3.5 3.3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "m15.8 8.2.2 4.1h4.2q.9-1.4 1-3-.1-1.7-2-1.8-1.7.1-3.4.7m4.8.1v2.4Zm-.3-.2v3.2Zm-.3-.2v3.8Zm-.4 0v3Zm-.3 0v3Zm-.4-.2V11Zm-.3 0V11Zm-.3 0V11Zm-.4 0V11Zm-.3.3v3Zm-.4 0v3.5ZM17 8v3.2Zm-.3 0v3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M20.6 8.3v2.4m-.3-2.6v3.2M20 7.9v3.8M19.6 8v3m-.3-3v3m-.4-3.2V11m-.3-3.2V11m-.3-3.1v3m-.4-3V11m-.3-3v3.2m-.4-3v3.4M17 8v3.2M16.6 8v3.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M18.5 7.9c-.7 0-2.3.8-2.1 1.8.2 1.4 1 .9 2.2.7l.8.2q.5.6 1 .2h.5v2h-5.4V8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M16 7.9a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7m.8-.2a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7m.8-.2a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M18.3 7.4a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M19 7.3a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7m.8 0a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6m.7.3a.3.3 0 1 1 0-.7.3.3 0 0 1 0 .7m.6.4a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6m.4.6a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6m.2.7a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6m0 .7a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .7m-.1.7a.3.3 0 1 1 0-.6.3.3 0 0 1 0 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M16 8v.4c.8-.1 2-.6 3-.6q1.7 0 1.8 1.4 0 1.6-1 2.8l.6.3q.9-1.4 1-3c0-1-.8-2-2.1-2-1.2 0-2.4.5-3.4.7m-.4-4.5-.4.7.4.6.3-.6zm0 1.7-.4.6.4.7.3-.7zM14.2 5l.6.3.5-.3-.5-.3zm1.4 0 .5.3.6-.3-.6-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M15.5 5.3a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 2.1a.7.7 0 1 0 0-1.4.7.7 0 0 0 0 1.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M15.3 6v.4h-.5m1.3 0h-.5V6m-.8.8H16"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M14.8 7.8A8 8 0 0 1 14 11l.8-.3.3-2.8zm1.3 0-.4.1q0 1.1.4 2.8l.7.3Q16 9.6 16 7.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M15.5 10.3q-1.4 0-1.6 1.5c-.2-.4-1-1.6-1.9-1.4-.5 0-1 .8-.9 1.5-.4-1.1-1.6-1.3-2.4-.6.7.6 1 2.5 1.7 3.3h10c.7-.8 1-2.7 1.9-3.3-1-.7-2.1-.5-2.5.6q0-1.2-.9-1.5c-.8-.2-1.7 1-2 1.4q-.1-1.5-1.4-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M20.5 14.6c0 .4-2.3.8-5 .8s-5-.4-5-.8 2.2-.6 5-.6 5 .2 5 .6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "M15.5 7.9a.2.2 0 1 0 0-.5.2.2 0 0 0 0 .5m0 .5a.2.2 0 1 0 0-.5.2.2 0 0 0 0 .5m0 .6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 .6a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6m0 .7a.3.3 0 1 0 0-.7.3.3 0 0 0 0 .7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M15.3 10.6v.4zm.3 0v.4zm-.5 0v.4zm.7 0v.4zm-1 .2v.3zm1.3 0v.3zm-4 0q0 .2.2.3v-.3zm6.7 0h-.1l-.1.3zm-6.4 0 .1.3zm6 0v.3l.1-.2zm-5.6 0v.4h.1V11zm5.4 0-.1.1v.3q0 .1 0 0v-.8m-6.3 0v.4h.2v.2zm7 0v.3q0 .2 0 0h.1zm-4.4.3v.3h.1zm2 0h-.1v.3zm-1 0v.2l-.2.4H15l-.2-.1q.5.7.6 1.6v.1h.1q.1-1.1.7-1.6v-.1l-.3.1h-.2l-.2-.4zm-2.4 0v.3h.1zm4.7 0-.1.2q0 .2 0 0zm-6 0q-.2 0-.1.1l.1.2zm7.4 0-.2.3zm-9.6.2.2.2zm11.7 0-.2.2v.1zm-11.4 0v.2l.1.2h.1V11zm11 0v.4l.1-.2zm-11.6 0v.2l.2.1-.1-.2zm12.3 0-.2.2zm-7.3.1v.4h.1zm2.3 0-.1.3zm-4.3 0 .1.6q0 .2-.1 0H12q.6.6.8 1.2 0 .2 0 0V12q0-.3 0 0h-.2zm6.3 0-.3.5H18q-.2-.3-.1 0v1.3q0 .2 0 0 .3-.7.9-1.2h-.3q0 .2 0 0zm-8.3 0v.4h.1v-.3zm10.3 0v.3q0 .1 0 0zm-9 0 .1.2zm7.8 0-.2.3zm-8.8.2v.3zm9.7 0v.3zm-8.8.1.1.2zm8 0-.2.3zM10 12l.2.5h-.4l1 1q0 .2 0 0l-.1-.8v-.4q0-.2 0 0v.2h-.3zm10.8 0h-.1l-.4.4q-.1.1-.2 0v-.1q0-.2-.1 0v.4l-.1.8q0 .2 0 0l1-1q.2 0 0 0h-.3l.2-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffd83d",
    d: "m10.7 14.2.1.4Zm.2-.1.2.4Zm.3 0 .1.4Zm.3-.1v.4Zm.3 0 .1.4Zm.4 0v.4Zm.4-.2v.5Zm.3 0v.5Zm.3 0v.5Zm.3 0v.4Zm.4 0v.4Zm.3 0v.4Zm.4 0v.4Zm.4 0v.4Zm5.3.4-.2.4ZM20 14l-.1.4Zm-.3 0v.4Zm-.3-.1v.4Zm-.3 0v.4Zm-.4 0v.4Zm-.3-.2v.5Zm-.4 0v.5Zm-.3 0v.5Zm-.3 0v.4Zm-.4 0v.4Zm-.3 0v.4Zm-.3 0v.4Zm-.4 0v.4Zm-.5-.1v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.1,
    d: "m10.7 14.2.1.4m.1-.5.2.4m.1-.5.1.5m.2-.5v.4m.3-.4.1.4m.3-.4v.4m.4-.6v.5m.3-.4v.4m.3-.5v.5m.3-.5v.4m.4-.4v.4m.3-.4v.4m.4-.5v.5m.4-.5v.5m5.3 0-.2.4M20 14l-.1.4m-.2-.5v.5m-.3-.5v.4M19 14v.4m-.4-.4v.4m-.3-.6v.5m-.4-.4v.4m-.3-.5v.5m-.3-.5v.4m-.4-.4v.4m-.3-.4v.4m-.3-.5v.5m-.4-.5v.5m-.5-.5v.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLi);
export default __webpack_public_path__ + "static/media/li.575d8e27caea90a5c150d7e4b7fb3cb1.svg";
export { ForwardRef as ReactComponent };